import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import {
  Button,
  ConditionalTooltip,
  RenderWhen,
  YesNoModal
} from "../../../../../../components";
import { isAdmin } from "../../../../../../utils";
import { useDeleteLayout } from "../../hooks";
import { getIsEnabled } from "./utils";

const admin = isAdmin();

type Props = {
  onClick?: () => void;
};

const getTooltipMessage = (type?: string) => {
  if (!admin && type === "shared")
    return "You're not allowed to delete shared layouts.";
  return "You can't delete the ReversingLabs default layout.";
};

const DeleteButton = ({ onClick }: Props) => {
  const [opened, setOpened] = useState(false);

  const { id, type } = useParams();
  const navigate = useNavigate();

  const { remove } = useDeleteLayout();

  const handleClick = () => {
    setOpened(true);
  };

  const closeModal = () => {
    setOpened(false);
  };

  const confirm = () => {
    if (!id || !type) return;
    onClick?.();
    remove({ id, type }).then(() => {
      navigate("/samples/layouts/");
    });
  };

  const isEnabled = getIsEnabled(admin, type);

  const showTooltip = type === "rl" || (type === "shared" && !admin);

  return (
    <>
      <ConditionalTooltip
        tooltip={getTooltipMessage(type)}
        condition={showTooltip}
      >
        <div>
          <Button
            data-testid="layout-delete-button"
            disabled={!isEnabled}
            onClick={handleClick}
            variant="secondary"
          >
            DELETE
          </Button>
        </div>
      </ConditionalTooltip>
      <YesNoModal
        buttonLabels={{ yes: "DELETE", no: "CANCEL" }}
        destructiveAction
        show={opened}
        title="Delete Layout"
        onClickNo={closeModal}
        onClickYes={confirm}
      >
        <p>Are you sure you want to delete layout?</p>
        <RenderWhen condition={type === "shared"}>
          <br />
          <p>
            Users who are using this layout will be switched to the system
            default one.
          </p>
        </RenderWhen>
      </YesNoModal>
    </>
  );
};

export default DeleteButton;
